import React, {
  useCallback,
  useRef,
  useState,
} from "react";
import styled from "styled-components";
import H2 from "../../DS/Typo/H2";
import Wrapper from "../../DS/Wrapper/Wrapper";
import bod from "../../assets/images/bod.png";
import EmailSubscribe from "../EmailSubscribe/EmailSubscribe";
// import LightDivider from "../LightDivider/LightDivider";
import ScrollContainer from "react-indiana-drag-scroll";
import SubTitle2 from "../../DS/Typo/SubTitle2";
import DS from "../../DS/DS";
import Table from "../Table/Table";
import Body1 from "../../DS/Typo/Body1";
import H4 from "../../DS/Typo/H4";
import navigation from "../../assets/icons/location_red.svg";
import mobile from "../../assets/icons/mobile_dark_red.svg";
import mail from "../../assets/icons/mail_dark_red.svg";
import { Link } from "react-router-dom";
import mark from "../../assets/images/mark.png";
const MarkImg = styled.img`
  position: absolute;
  top: 200%;
  right: 0;
  width: 110px;
`;
const LinkContainer = styled.div`
  margin-top: 10px;
  & > a,
  & > div {
    display: flex;
    margin-bottom: 10px;
    img {
      margin-right: 12px;
      width: 14px;
      height: 16px;
      margin-top: 6px;
    }
  }
`;

const CustomLink = styled(Link)`
  color: inherit;
`;

const data = [
  {
    title: "Community Service",
    data: [
      {
        index: "1",
        unit: "Lawrence",
        name: "Andy Bradford",
        address: "",
        phone: ["256-476-5161"],
        email: "andyb816@icloud.com",
        first: "2025",
        second: "",
        ends: "2028(1)",
      },
      {
        index: "2",
        unit: "Cherokee",
        name: "Ann Beddingfield",
        address: "",
        phone: ["256-504-9428"],
        email: "annkb@tds.net",
        first: "2024",
        second: "",
        ends: "2027(1)",
      },
      {
        index: "3",
        unit: "Fayette, Secretary",
        name: "Carol Abernathy",
        address: "",
        phone: ["205-662-4766"],
        email: "cabernathy529@gmail.com",
        first: "2025",
        second: "",
        ends: "2028(1)",
      },
      {
        index: "4",
        unit: "Walker",
        name: "Shirley Mitchell",
        subName: "",
        address: "",
        phone: ["205-717-4027"],
        email: "akasam55@att.net",
        first: "2023",
        second: "",
        ends: "2026(1)",
      },
      {
        index: "5",
        unit: "Lee, Vice Chair",
        name: "Kathy Killcreas",
        address: "",
        phone: ["251-404-6862"],
        email: "kbkillcreas@gmail.com",
        first: "2021",
        second: "2024",
        ends: "2027(2)",
      },
      {
        index: "6",
        unit: "Dallas, Chair",
        name: "Jeanie Ward",
        address: "",
        phone: ["334-505-1617"],
        email: "Jeanie_ward@yahoo.com",
        first: "2022",
        second: "2025",
        ends: "2028(2)",
      },
      {
        index: "7",
        unit: "Montgomery",
        name: "Bettie Lee",
        address: "",
        phone: ["334-239-8195"],
        email: "bettieblee924@gmail.com",
        first: "2026",
        second: "",
        ends: "2029(1)",
      },
      {
        index: "8",
        unit: "Mobile",
        name: "Hilda Jenkins",
        address: "",
        phone: ["251-422-1468"],
        email: "hijenk@bellsouth.net",
        first: "2026",
        second: "2024",
        ends: "2029(1)",
      },
      {
        index: "9",
        unit: "Covington",
        name: "Lorena Bryant",
        address: "",
        phone: ["334-858-6506"],
        email: "lorena624@aol.com",
        first: "2025",
        second: "",
        ends: "2028(1)",
      },
      {
        index: "10",
        unit: "TUARA",
        name: "Bobby Ray Hicks",
        address: "",
        phone: ["205-752-4802 (hm)", "205-242-4963 (cell)"],
        email: "hicksbobbyray@gmail.com",
        first: "2023",
        second: "2026",
        ends: "2026(1)",
      },
      {
        index: "",
        unit: "Liaison",
        name: "John Paul Jones",
        subName: "Treasurer",
        address: "",
        phone: ["251-689-1126"],
        email: "johnpaul.aera@gmail.com",
        first: "",
        second: "",
        ends: "",
      },
    ],
  },
  {
    title: "Constitution & Bylaws",
    data: [
      {
        index: "1",
        unit: "Limestone, Secretary",
        name: "Pat Gartman",
        address: "",
        phone: ["256-777-7153"],
        email: "gartmanpat347@gmail.com",
        first: "2023",
        second: "2026",
        ends: "2029(2)",
      },
      {
        index: "2",
        unit: "Marshall",
        name: "Tricia Hopper",
        address: "",
        phone: ["256-506-6216"],
        email: "tlhopper.rdb@gmail.com",
        first: "2021",
        second: "2024",
        ends: "2027(2)",
      },
      {
        index: "3",
        unit: "Sumter",
        name: "Eleanor James",
        address: "",
        phone: ["205-499-9566"],
        email: "eleanorjames53@yahoo.com",
        first: "2025",
        second: "",
        ends: "2028(1)",
      },
      {
        index: "4",
        unit: "Shelby",
        name: "Robin Ayers",
        address: "",
        phone: ["251-391-7503"],
        email: "",
        first: "2026",
        second: "",
        ends: "2029(1)",
      },
      {
        index: "5",
        unit: "Chambers",
        name: "Wanda Huguley",
        address: "",
        phone: ["706-518-5010"],
        email: "elsie.huguley@gmail.com",
        first: "2024",
        second: "",
        ends: "2027(1)",
      },
      {
        index: "6",
        unit: "Marengo",
        name: "Annie Robertson",
        address: "",
        phone: ["205-919-8081"],
        email: "robertsonannie1957@gmail.com",
        first: "2022",
        second: "2025",
        ends: "2028(2)",
      },
      {
        index: "7",
        unit: "Montgomery",
        name: "Pauline George",
        address: "",
        phone: ["334-221-8186"],
        email: "pwgeorgeala@gmail.com",
        first: "2025",
        second: "",
        ends: "2028(1)",
      },
      {
        index: "8",
        unit: "Mobile",
        name: "Herbert White",
        address: "",
        phone: ["251-454-4787"],
        email: "hkhwhite@yahoo.com",
        first: "2021",
        second: "2024",
        ends: "2027(2)",
      },
      {
        index: "9",
        unit: "Dale, Chair",
        name: "Dinah Woodham",
        address: "",
        phone: ["334-718-4927"],
        email: "woodhamdinah@gmail.com",
        first: "2025",
        second: "",
        ends: "2028(1)",
      },
      {
        index: "10",
        unit: "Morgan, Vice Chair",
        name: "Bobby Simmons",
        address:
          "",
        phone: ["256-303-5626"],
        email: "s00164226@gmail.com",
        first: "2025",
        second: "",
        ends: "2028(1)",
      },
      {
        index: "",
        unit: "Liaison",
        name: "Melba Wiegand",
        subName: "AERA Parliamentarian",
        address: "",
        phone: ["205-746-5288"],
        email: "melbawiegand@gmail.com",
        first: "",
        second: "",
        ends: "",
      },
    ],
  },
  {
    title: "Legislative",
    data: [
      {
        index: "1",
        unit: "Limestone",
        name: "Elaine McCord",
        subName: "",
        address: "",
        phone: ["256-777-1399"],
        email: "ieemccord@gmail.com",
        first: "2023",
        second: "2026",
        ends: "2029(2)",
      },
      {
        index: "1",
        unit: "Franklin",
        name: "Sandy Gibson",
        address: "",
        phone: ["256-810-6917"],
        email: "chuckgib@bellsouth.net",
        first: "2024",
        second: "",
        ends: "2027(1)",
      },
      {
        index: "2",
        unit: "Madison",
        name: "Dr. Waymond Burke",
        address: "",
        phone: ["256-506-1975"],
        email: "weburke1831@gmail.com",
        first: "2025",
        second: "",
        ends: "2028(1)",
      },
      {
        index: "2",
        unit: "Marshall, Vice Chair",
        name: "Stanley Mahan",
        address: "",
        phone: ["256-506-1975"],
        email: "sdmahan1@gmail.com",
        first: "2023",
        second: "2026",
        ends: "2029(2)",
      },
      {
        index: "3",
        unit: "Hale",
        name: "Mary K. Bell",
        address: "",
        phone: ["334-507-3657"],
        email: "marykatebell2020@gmail.com",
        first: "2024",
        second: "",
        ends: "2027(1)",
      },
      {
        index: "4",
        unit: "Jefferson",
        name: "Jacqueline Oglesby",
        subName: "",
        address: "",
        phone: ["205-230-3020"],
        email: "1951jackie02@gmail.com",
        first: "2023",
        second: "2026",
        ends: "2029(2)",
      },
      {
        index: "4",
        unit: "Jefferson",
        name: "Valaida Gentry",
        address: "",
        phone: ["205-915-1076"],
        email: "vggentry@yahoo.com",
        first: "2023",
        second: "2026",
        ends: "2029(1)",
      },
      {
        index: "4",
        unit: "Talladega, Chair",
        name: "Martha Livingston",
        address: "",
        phone: ["256-493-4000"],
        email: "livingston21@hotmail.com",
        first: "2025",
        second: "",
        ends: "2028(1)",
      },
      {
        index: "4",
        unit: "Shelby",
        name: "Bobby J. Pierson",
        address: "",
        phone: ["205-915-0787"],
        email: "qmega4@charter.net",
        first: "2025",
        second: "",
        ends: "2028(1)",
      },
      {
        index: "5",
        unit: "Lee",
        name: "Lori Hardee",
        address: "",
        phone: ["334-559-8026"],
        email: "hardeelori@gmail.com",
        first: "2020",
        second: "",
        ends: "2029(1)",
      },
      {
        index: "5",
        unit: "Elmore",
        name: "E’lissa Ritchey",
        address: "",
        phone: ["334-306-4786"],
        email: "elissagr@gmail.com",
        first: "2024",
        second: "",
        ends: "2027(1)",
      },
      {
        index: "6",
        unit: "Dallas",
        name: "Dorothy Irvin",
        address: "",
        phone: ["334-505-9280"],
        email: "drthyirvin@gmail.com",
        first: "2025",
        second: "",
        ends: "2028(1)",
      },
      {
        index: "7",
        unit: "Russell",
        name: "Dr. Clementine Warren",
        subName: "",
        address: "",
        phone: ["762-822-9615"],
        email: "dr.cwarren1957@gmail.com",
        first: "2025",
        second: "",
        ends: "2028(1)",
      },
      {
        index: "7",
        unit: "Montgomery",
        name: "Zack Buckner",
        address: "",
        phone: ["334-322-5209"],
        email: "zbuckner@aol.com",
        first: "2024",
        second: "",
        ends: "2027(1)",
      },
      {
        index: "8",
        unit: "Mobile",
        name: "Dianne Martin",
        address: "",
        phone: ["251-421-1603"],
        email: "diannesmar@aol.com",
        first: "2025",
        second: "",
        ends: "2028(1)",
      },
      {
        index: "8",
        unit: "Mobile",
        name: "Derrick Pettaway",
        subName: "",
        address: "",
        phone: ["251-209-5261", "251-645-8850"],
        email: "derpet@msn.com",
        first: "2025",
        second: "",
        ends: "2028(1)",
      },
      {
        index: "8",
        unit: "Baldwin",
        name: "Bobbie Beverly",
        address: "",
        phone: ["251-978-3094"],
        email: "bobbiebeverly@hotmail.com",
        first: "2026",
        second: "",
        ends: "2029(1)",
      },
      {
        index: "9",
        unit: "Coffee, Secretary",
        name: "Barbara Cole",
        address: "",
        phone: ["334-389-6335"],
        email: "colebarbarab@gmail.com",
        first: "2022",
        second: "2025",
        ends: "2028(2)",
      },
      {
        index: "10",
        unit: "UABRA",
        name: "Leroy Cowan",
        subName: "",
        address: "",
        phone: ["205-923-7003 (hm)", "205-478-6110 (cell)"],
        email: "leroycowan86@yahoo.com",
        first: "2022",
        second: "2025",
        ends: "2028(2)",
      },
      {
        index: "",
        unit: "Liaison",
        name: "Debbie Landers Martin",
        subName:
          "AERA Member At Large Legislative",
        address: "",
        phone: ["256-390-6185"],
        email: "debbielscott@bellsouth.net",
        first: "",
        second: "",
        ends: "",
      },
    ],
  },
  {
    title: "Membership",
    data: [
      {
        index: "1",
        unit: "Winston, Chair",
        name: "Donna Jones",
        address: "",
        phone: ["256-577-8581"],
        email: "jonesfourth@yahoo.com",
        first: "2023",
        second: "2026",
        ends: "2029(2)",
      },
      {
        index: "2",
        unit: "Etowah",
        name: "Nancy Mitchell",
        address: "",
        phone: ["256-504-7660"],
        email: "nmitchell54@bellsouth.net",
        first: "2024",
        second: "",
        ends: "2027(1)",
      },
      {
        index: "3",
        unit: "Bibb",
        name: "Vickie Brown",
        address: "",
        phone: ["205-266-8092"],
        email: "vgbrown06@gmail.com",
        first: "2022",
        second: "2025",
        ends: "2028(2)",
      },
      {
        index: "4",
        unit: "Birmingham, Vice Chair",
        name: "Dr. Lisa Stewart",
        address: "",
        phone: ["205-266-8092"],
        email: "stewartbham1@gmail.com",
        first: "2023",
        second: "2026",
        ends: "2029(1)",
      },
      {
        index: "5",
        unit: "Elmore, Secretary",
        name: "JoAnn Wilson",
        address: "",
        phone: ["334-201-6354"],
        email: "paccky60@gmail.com",
        first: "2025",
        second: "",
        ends: "2028(1)",
      },
      {
        index: "6",
        unit: "Wilcox",
        name: "Marvin Carter",
        address: "",
        phone: ["334-303-4785"],
        email: "mecarter@frontiernet.net",
        first: "2022",
        second: "2025",
        ends: "2028(2)",
      },
      {
        index: "7",
        unit: "Montgomery",
        name: "Dorothy G. Henry",
        address: "",
        phone: ["334-701-3332"],
        email: "dghenry7005@att.net",
        first: "2023",
        second: "2026",
        ends: "2029(2)",
      },
      {
        index: "8",
        unit: "Conecuh",
        name: "Arnita Holder",
        address: "",
        phone: ["251-752-1784"],
        email: "leighzcam@yahoo.com",
        first: "2024",
        second: "",
        ends: "2027(1)",
      },
      {
        index: "9",
        unit: "Dale",
        name: "Beverly Jones Lampkin",
        address: "",
        phone: ["334-803-1691"],
        email: "lampkinbeverly45@gmail.com",
        first: "2025",
        second: "",
        ends: "2028(1)",
      },
      {
        index: "10",
        unit: "Coastal Community College",
        name: "Franklin Edward",
        address: "",
        phone: ["251-363-1867"],
        email: "franklin.edward67@gmail.com",
        first: "2025",
        second: "",
        ends: "2028(1)",
      },
      {
        index: "",
        unit: "Liaison",
        name: "Vivian Crosby",
        subName:
          "AERA Member at Large, Membership",
        address: "",
        phone: ["334-309-6209"],
        email: "vivian.crosby@att.net",
        first: "",
        second: "",
        ends: "",
      },
    ],
  },
  {
    title: "Nomination & Elections",
    data: [
      {
        index: "1",
        unit: "Cullman",
        name: "Paul Derrick",
        address: "",
        phone: ["256-339-2984"],
        email: "plderrick76@gmail.com",
        first: "2026",
        second: "",
        ends: "2029(1)",
      },
      {
        index: "2",
        unit: "Etowah",
        name: "Donna Eaves",
        address: "",
        phone: ["256-831-1220"],
        email: "deaves1036@aol.com",
        first: "2021",
        second: "2024",
        ends: "2027(2)",
      },
      {
        index: "3",
        unit: "Tuscaloosa, Secretary",
        name: "Alma Wyatt Jones",
        subName: "",
        address: "",
        phone: ["205-345-5514 (hm)", "205-242-4442 (cell)"],
        email: "awj5514@aol.com",
        first: "2025",
        second: "",
        ends: "2028(1)",
      },
      {
        index: "4",
        unit: "Shelby",
        name: "Kenneth Dukes",
        subName: "",
        address: "",
        phone: ["205-902-5137"],
        email: "revdukes2@hotmail.com",
        first: "2026",
        second: "",
        ends: "2029(1)",
      },
      {
        index: "5",
        unit: "Autauga",
        name: "Teresa Bufkin",
        address: "",
        phone: ["334-300-2314"],
        email: "teresa.bufkin@yahoo.com",
        first: "2024",
        second: "",
        ends: "2027(1)",
      },
      {
        index: "6",
        unit: "Clarke, Vice Chair",
        name: "Renee Smith",
        subName: "",
        address: "",
        phone: ["251-513-5732"],
        email: "rmsmenu1@gmail.com",
        first: "2025",
        second: "",
        ends: "2028(1)",
      },
      {
        index: "7",
        unit: "Montgomerry",
        name: "Warren George",
        address: "",
        phone: ["334-221-7705 (cell)", "334-288-3415 (hm)"],
        email: "wrgeorgeaera@gmail.com",
        first: "2026",
        second: "",
        ends: "2029(1)",
      },
      {
        index: "8",
        unit: "North Mobile",
        name: "Douglas July",
        address: "",
        phone: ["251-401-0863"],
        email: "dljulysr@yahoo.com",
        first: "2024",
        second: "",
        ends: "2027(1)",
      },
      {
        index: "9",
        unit: "Covington, Chair",
        name: "Margaret Sanders",
        address: "",
        phone: ["334-488-3529"],
        email: "sandersmg1951@gmail.com",
        first: "2022",
        second: "2025",
        ends: "2028(2)",
      },
      {
        index: "10",
        unit: "",
        name: "VACANT",
        address: "",
        phone: [],
        email: "",
        first: "",
        second: "",
        ends: "",
      },
      {
        index: "",
        unit: "Liaison",
        name: "Rex Cheatham",
        subName: "AERA Vice President",
        address: "",
        phone: ["256-565-2027"],
        email: "rex.rexcheatham@yahoo.com",
        first: "",
        second: "",
        ends: "",
      },
    ],
  },
];

const StateCommitteesContainer = styled.div``;

const BODImg = styled.img`
  margin: 54px auto;
  max-width: 100%;
`;

const TabItem = styled.div<{
  isActive: boolean;
}>`
  ${({ isActive }) => `
    box-shadow: inset 0px -${
      isActive ? 6 : 0
    }px 0px ${DS.colors.magenta};
    &:hover {
    box-shadow: inset 0px -${
      isActive ? 6 : 2
    }px 0px ${DS.colors.magenta};
    }
  `}
  margin-right: 50px;
  padding-bottom: 17px;
  cursor: pointer;
  transition: all 0.3s ease;
`;

const Tab = styled.div`
  display: flex;
`;

const TabScroll = styled.div`
  pointer-events: none;
  position: absolute;
  right: -1px;
  top: 0px;
  bottom: 0px;
  width: 30px;
  box-shadow: 0px 0px 30px 30px rgb(255 255 255);
`;

const StateCommittees = () => {
  const [activeIndex, setIndex] = useState(0);
  const ref = useRef<ScrollContainer>(null);
  const onClick = useCallback(
    (index: number) => {
      setIndex(index);
    },
    [setIndex]
  );
  const scrollTo = useCallback(
    (div: HTMLDivElement) => {
      ref.current?.getElement().scrollTo({
        left: div.offsetLeft,
        behavior: "smooth",
      });
    },
    []
  );

  return (
    <StateCommitteesContainer>
      <Wrapper
        type="m"
        display="flex"
        alignItems="center"
        flexDirection="column"
      >
        <H2
          style={{
            textAlign: "center",
            maxWidth: 936,
          }}
        >
          Alabama Education Retirees Association
          District Map
        </H2>
        <BODImg
          src={bod}
          alt="board of director"
        />
      </Wrapper>
{/*       <Wrapper
        type="m"
        display="flex"
        alignItems="center"
        flexDirection="column"
        marginTop="30px"
        marginBottom="67px"
      >
        <H2
          style={{
            textAlign: "center",
            maxWidth: 936,
          }}
        >
          2024-2025 State Committees
        </H2>
      </Wrapper> */}
      <Wrapper
        type="m"
        style={{
          position: "relative",
        }}
      >
        <ScrollContainer
          ref={ref}
          style={{
            position: "relative",
          }}
        >
          <Tab>
            {data.map(({ title }, index) => {
              return (
                <TabItem
                  key={index}
                  isActive={index === activeIndex}
                  onClick={(e) => {
                    onClick(index);
                    console.log(e.currentTarget);
                    scrollTo(e.currentTarget);
                  }}
                >
                  <SubTitle2
                    style={{
                      whiteSpace: "nowrap",
                    }}
                  >
                    {title}
                  </SubTitle2>
                </TabItem>
              );
            })}
            <div
              style={{
                width: 1,
                height: 1,
                flexShrink: 0,
              }}
            ></div>
          </Tab>
        </ScrollContainer>
        <TabScroll />
      </Wrapper>
      <Wrapper type="m" marginTop="50px">
        <Table
          spacing={"2%"}
          mobileCols={["20%", "80%"]}
          cols={[
            "10%",
            "30%",
            "36%",
            "8%",
            "8%",
            "8%",
          ]}
          headers={[
            <Body1 fontColor="white">
              District
            </Body1>,
            <Body1 fontColor="white">
              Local Unit Office
            </Body1>,
            <Body1 fontColor="white">
              Name and Contact Information
            </Body1>,
            <Body1 fontColor="white">1st</Body1>,
            <Body1 fontColor="white">2nd</Body1>,
            <Body1 fontColor="white">Ends</Body1>,
          ]}
          mobileHeaders={[
            <Body1>District</Body1>,
            <Body1>Local Unit Office</Body1>,
            <Body1>
              Name and Contact Information
            </Body1>,
            <Body1>1st</Body1>,
            <Body1>2nd</Body1>,
            <Body1>Ends</Body1>,
          ]}
          data={data[activeIndex].data.map(
            (row) => {
              return [
                <Body1>{row.index}</Body1>,
                <Body1>{row.unit}</Body1>,
                <>
                  <H4>{row.name}</H4>
                  {row.subName ? (
                    <Body1>{row.subName}</Body1>
                  ) : null}
{row.phone?.length || row.email?.length || row.address?.length ? (
                    <LinkContainer>
                    { row.phone.length ? (
                      <div>
                        <img
                          src={mobile}
                          alt={"phone"}
                        />
                        <Body1>
                          {row.phone.map(
                            (_phone, index) => {
                              return (
                                <CustomLink
                                  to={{
                                    pathname: `tel:${_phone}`,
                                  }}
                                  key={index}
                                  target="_top"
                                >
                                  {_phone}
                                  {index + 1 <
                                  row.phone.length
                                    ? ", "
                                    : ""}
                                </CustomLink>
                              );
                            }
                          )}
                        </Body1>
                      </div>) : null }
                      { row.email.length ? (
                        <Link
                          to={{
                            pathname: `mailto:${row.email}`,
                          }}
                          target="_top"
                        >
                          <img
                            src={mail}
                            alt={"mail"}
                          />
                          <Body1
                            style={{
                              overflowWrap:
                                "anywhere",
                            }}
                          >
                            {row.email}
                          </Body1>
                        </Link>
                      ) : null}
                      { row.address.length ? (
                      <div>
                        <img
                          src={navigation}
                          alt={"map"}
                        />
                        <Body1>
                          {row.address}
                        </Body1>
                      </div>): null }
                    </LinkContainer>
                  ) : null}
                </>,
                <Body1>{row.first}</Body1>,
                <Body1>{row.second}</Body1>,
                <Body1>{row.ends}</Body1>,
              ];
            }
          )}
        />
      </Wrapper>
      {/* <LightDivider marginTop="60px" /> */}

      <Wrapper
        type="m"
        marginTop="60px"
      ></Wrapper>
      <EmailSubscribe />
      <Wrapper
        type="m"
        marginTop="50px"
      ></Wrapper>
      <MarkImg src={mark} alt="AERA" />
    </StateCommitteesContainer>
  );
};

export default StateCommittees;
